import React from "react"
import Link from "next/link"
import {Trans} from "@lingui/react/macro"
import styles from "./styles.module.css"
import SmartImage from "./SmartImage"
import {buildArticleUrl, pickThumbnail, slugify} from "./utils"

export default function RecommendationsSidebar({context, items, className}) {
    if (!Array.isArray(items) || items.length === 0) return null

    return (
        <aside className={[styles.sidebar, className].filter(Boolean).join(" ")}>
            <div className={styles.sidebarSticky}>
                <h3 className={styles.sidebarTitle}><Trans>Articles recommandés</Trans></h3>
                <ul className={styles.sidebarList}>
                    {items.map(it => {
                        const href = buildArticleUrl(context, it.aid, slugify(it.title))
                        const thumb = pickThumbnail(it)
                        const initial = (it.title || "?").trim().charAt(0).toUpperCase()
                        const externalUrl = it.url_source
                        const inner = (
                            <>
                                <span style={{display:"block"}} className={styles.sidebarThumb}>
                                    <SmartImage
                                        src={thumb}
                                        alt={it.title || ""}
                                        className={styles.sidebarThumbImg}
                                        loading="lazy"
                                        fallback={<span style={{display:"block"}} className={styles.sidebarThumbPlaceholder}>{initial}</span>}
                                    />
                                </span>
                                <span style={{display:"block"}} className={styles.sidebarMeta}>
                                    <span style={{display:"block"}} className={styles.sidebarItemTitle}>{it.title}</span>
                                    {it.section && (
                                        <span style={{display:"block"}} className={styles.sidebarItemSection}>
                                            {Array.isArray(it.breadcrumb) && it.breadcrumb.length > 0
                                                ? it.breadcrumb.slice(-1)[0]
                                                : it.section}
                                        </span>
                                    )}
                                </span>
                            </>
                        )
                        return (
                            <li key={it.aid} className={styles.sidebarItem}>
                                {externalUrl ? (
                                    <a className={styles.sidebarLink} href={externalUrl} target="_blank" rel="noopener noreferrer">
                                        {inner}
                                    </a>
                                ) : (
                                    <Link href={href} passHref legacyBehavior>
                                        <a className={styles.sidebarLink}>{inner}</a>
                                    </Link>
                                )}
                            </li>
                        )
                    })}
                </ul>
            </div>
        </aside>
    )
}
